<app-sexual-performance
  htmlTitle="<strong>Support Sexual Health While Treating Hair Loss</strong>"
  question="We strongly recommend including ED medication in your prescription. Would you like to add it to your treatment plan?"
>
  <p class="mb-4">
    Hair loss and sexual health are often influenced by the same underlying factors, including hormones, circulation,
    stress, and overall vascular health.
    <strong>Some hair loss treatments can also affect libido or sexual performance in certain individuals.</strong>
  </p>
  <p class="mb-4">
    <strong
      >Erectile dysfunction medication helps support healthy blood flow and sexual performance, providing confidence and
      peace of mind while you focus on restoring your hair.</strong
    >
  </p>
  <p class="mb-4">
    We offer <strong>discreet</strong>, clinician-prescribed Sildenafil or Tadalafil for use as needed.
    <strong
      >This option gives you dependable erections and improved stamina when you want it, without interrupting your
      overall treatment plan.</strong
    >
  </p>
</app-sexual-performance>
